import { LitElement, TemplateResult, html, nothing } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { ButtonSize } from 'apps/webcomponents/src/ui/gzIconButton/types';
import { translateFn } from 'apps/webcomponents/src/utils/translator.helper';
import { FontSizes } from 'apps/webcomponents/src/types/common/types';
import { WEB_COMPONENT_GATHERING_DATA_INFO } from 'apps/webcomponents/src/webcomponents.constants';
import { formatLargeNumber } from '../../../../utils/formatter.utils';

@customElement(WEB_COMPONENT_GATHERING_DATA_INFO)
export class GatheringDataInfoWebComponent extends LitElement {
  /**
   * Number of users that are actively gathering data.
   */
  @property({type: Number, attribute: true, reflect: true})
  nrUsers: number;

  /**
   * Number of behavioural patterns that are actively gathering data.
   */
  @property({type: Number, attribute: true, reflect: true})
  behavioralPatterns = 0;

  /**
   * Remaining time in seconds (timestamp).
   */
  @property({type: Number, attribute: true, reflect: true})
  remainingDays: number;

  @property({type: Boolean, attribute: true, reflect: true})
  isLearning = true;

  @property({type: Boolean, attribute: true, reflect: true})
  showRemainingDays = true;

  static get styles() {
    return styles;
  }

  render(): TemplateResult {
    let userProfilesText = 'Actively gathering data from {nrUsers} behavioral profiles.';
    if (this.behavioralPatterns) {
      userProfilesText =
        'Learning {behavioralPatternsCount} behavioral patterns for {nrUsers} unique behavioral profiles';
    } else if (!this.isLearning) {
        userProfilesText = 'Actively gathering data from {nrUsers} new behavioral profiles.';
    }

    return html`
      <div class="d-flex">
        <gz-icon-button icon="ds-icon-export" fontsize="${ButtonSize.SIZE_24}" showspinner></gz-icon-button>
        <div class="text-container ml-1">
          <gz-text fontsize="${FontSizes.PARAGRAPH_13}"
          >${translateFn(userProfilesText, {nrUsers: this.nrUsers})}
          </gz-text
          >
          ${this.showRemainingDays
            ? html`
              <gz-text fontsize="${FontSizes.PARAGRAPH_13}" class="gray-text">
                ${translateFn('Remaining days: {days}', {
                  days: this.remainingDays,
                })}
              </gz-text>`
            : nothing}
        </div>
      </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gathering-data-info': GatheringDataInfoWebComponent;
  }
}
